import { render, staticRenderFns } from "./image-component.vue?vue&type=template&id=b2618ef2&scoped=true"
import script from "./image-component.vue?vue&type=script&lang=js"
export * from "./image-component.vue?vue&type=script&lang=js"
import style0 from "./image-component.vue?vue&type=style&index=0&id=b2618ef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2618ef2",
  null
  
)

export default component.exports